import { Box, BoxProps, Text } from '@chakra-ui/react'

import { Skeleton } from '../SkeletonLoader'

type CardHeaderItemProps = BoxProps & {
  caption?: string
  subCaption?: string | number | null
  value?: string | number
  isLoading?: boolean
}

export const CardHeaderItem = ({
  caption,
  subCaption,
  value,
  isLoading,
  ...props
}: CardHeaderItemProps) => {
  return (
    <Box display="flex" flexDirection="column" alignItems="center" {...props}>
      <Skeleton isLoading={isLoading} h="12px" w="100%" mb="12px">
        <Text
          fontWeight="500"
          fontSize="12px"
          color="presets.neutral.80"
          mb="6px"
        >
          {caption}
        </Text>
      </Skeleton>

      <Skeleton isLoading={isLoading} h="28px" w="75%">
        <Text fontWeight="400" fontSize="28px" color="presets.turquoise.100">
          {value}
        </Text>
      </Skeleton>
    </Box>
  )
}
